import { api } from '../api';

/**
 * Fetch all countries that have existing visas configured
 * @returns {Promise<Array<{id: number, name: string, code: string}>>}
 */
const fetchCountriesWithExistingVisas = async () => {
  const response = await api.get('/admin/existing-visa-tree/countries');
  return response ? response.data : [];
};

/**
 * Fetch all companies that have existing visas for a given country
 * @param {number} countryId 
 * @returns {Promise<Array<{id: number|null, name: string}>>}
 */
const fetchCompaniesForCountry = async (countryId) => {
  const response = await api.get(`/admin/existing-visa-tree/countries/${countryId}/companies`);
  return response ? response.data : [];
};

/**
 * Fetch existing visas for a country and company combination
 * Sorted alphabetically with special types (multiple, none of these, other) at the end
 * @param {number} countryId 
 * @param {number|null} companyId 
 * @returns {Promise<Array<{id: number, name: string, type: string}>>}
 */
const fetchExistingVisasForCountryAndCompany = async (countryId, companyId) => {
  const response = await api.get(
    `/admin/existing-visa-tree/countries/${countryId}/companies/${companyId}/visas`
  );
  return response ? response.data : [];
};

/**
 * Fetch the complete tree structure for a visa
 * @param {number} visaId 
 * @returns {Promise<Object>}
 */
const fetchVisaTree = async (visaId) => {
  const response = await api.get(`/admin/existing-visa-tree/visas/${visaId}/tree`);
  return response ? response.data : null;
};

/**
 * Get indicative time for a node
 * @param {number} nodeId 
 * @returns {Promise<Object>}
 */
const getNodeIndicativeTime = async (nodeId) => {
  const response = await api.get(`/admin/existing-visa-tree/nodes/${nodeId}/indicative-time`);
  return response ? response.data : null;
};

export {
  fetchCountriesWithExistingVisas,
  fetchCompaniesForCountry,
  fetchExistingVisasForCountryAndCompany,
  fetchVisaTree,
  getNodeIndicativeTime,
};
